import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core';

import { DoodShopModel } from '@core/models/shop.model';
import { SHOP_STORE_ACTIVE_ACTIONS, SHOP_STORE_LOCAL_ACTIONS } from '@store/shop/shop.action';

@Injectable({ providedIn: 'root' })
export class ShopStoreDispatcher {
  constructor(private store: Store) {}

  // One
  upsertOne(entity: DoodShopModel): void {
    this.store.dispatch(SHOP_STORE_ACTIVE_ACTIONS.upsertOne({ entity }));
  }

  removeOne(id: string): void {
    this.store.dispatch(SHOP_STORE_ACTIVE_ACTIONS.removeOne({ id }));
  }

  // Active
  setActive(active: string): void {
    this.store.dispatch(SHOP_STORE_ACTIVE_ACTIONS.setActive({ active }));
  }

  insertActive(entity: DoodShopModel): void {
    this.store.dispatch(SHOP_STORE_ACTIVE_ACTIONS.insertActive({ entity }));
  }

  // Current page shop (route lifecycle), used by block visibility conditions
  setCurrentPageShop(id: string | null): void {
    this.store.dispatch(SHOP_STORE_LOCAL_ACTIONS.setCurrentPageShop({ id }));
  }

  // Slots
  setSlots(slots: number[]): void {
    this.store.dispatch(SHOP_STORE_LOCAL_ACTIONS.setSlots({ slots }));
  }

  // Status
  updateIsLoading(isLoading: boolean): void {
    this.store.dispatch(SHOP_STORE_LOCAL_ACTIONS.updateIsLoading({ isLoading }));
  }

  // Filter catalog
  setFilterCatalogIds(shopId: string, catalogIds: string[]): void {
    this.store.dispatch(SHOP_STORE_LOCAL_ACTIONS.setFilterCatalogIds({ shopId, catalogIds }));
  }

  resetFilterCatalogIds(shopId: string): void {
    this.store.dispatch(SHOP_STORE_LOCAL_ACTIONS.resetFilterCatalogIds({ shopId }));
  }

  reset(): void {
    this.store.dispatch(SHOP_STORE_LOCAL_ACTIONS.reset());
  }
}
